/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RegisterProfile
 */
export interface RegisterProfile {
  /**
   *
   * @type {string}
   * @memberof RegisterProfile
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof RegisterProfile
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof RegisterProfile
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof RegisterProfile
   */
  patronymic: string;
  /**
   *
   * @type {string}
   * @memberof RegisterProfile
   */
  birthday: string;
  /**
   * @type {boolean}
   * @memberOf RegisterProfile
   */
  pdAgreement: boolean;
  /**
   * @type {boolean}
   * @memberOf RegisterProfile
   */
  promoAccept: boolean;
}

export function RegisterProfileFromJSON(json: any): RegisterProfile {
  return RegisterProfileFromJSONTyped(json, false);
}

export function RegisterProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterProfile {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json['email'],
    firstName: json['firstName'],
    lastName: json['lastName'],
    patronymic: json['patronymic'],
    birthday: !exists(json, 'birthday') ? undefined : json['birthday'],
    promoAccept: json['promoAccept'],
    pdAgreement: json['pdAgreement']
  };
}

export function RegisterProfileToJSON(value?: RegisterProfile | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    firstName: value.firstName,
    lastName: value.lastName,
    patronymic: value.patronymic,
    birthday: value.birthday.split('.').reverse().join('-'),
    promoAccept: value.promoAccept,
    pdAgreement: value.pdAgreement,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum RegisterProfileFavouritesActionEnum {
  Add = 'add',
  Remove = 'remove',
  Clear = 'clear',
}
/**
 * @export
 * @enum {string}
 */
export enum RegisterProfileGenderEnum {
  Unknown = 'unknown',
  Male = 'male',
  Female = 'female',
}
